import * as React from 'react';
import { FixedSizeList } from 'react-window';

var VirtualizedList = function VirtualizedList(_ref) {
  var height = _ref.height,
      children = _ref.children,
      initialScrollOffset = _ref.initialScrollOffset,
      innerRef = _ref.innerRef,
      innerElementType = _ref.innerElementType,
      itemCount = _ref.itemCount,
      itemData = _ref.itemData,
      itemKey = _ref.itemKey,
      itemSize = _ref.itemSize,
      layout = _ref.layout,
      onItemsRendered = _ref.onItemsRendered,
      onScroll = _ref.onScroll,
      outerRef = _ref.outerRef,
      outerElementType = _ref.outerElementType,
      overscanCount = _ref.overscanCount,
      style = _ref.style,
      useIsScrolling = _ref.useIsScrolling,
      width = _ref.width;
  return /*#__PURE__*/React.createElement(FixedSizeList, {
    height: height,
    initialScrollOffset: initialScrollOffset,
    innerRef: innerRef,
    innerElementType: innerElementType,
    itemCount: itemCount,
    itemData: itemData,
    itemKey: itemKey,
    itemSize: itemSize,
    layout: layout,
    onItemsRendered: onItemsRendered,
    onScroll: onScroll,
    outerRef: outerRef,
    outerElementType: outerElementType,
    overscanCount: overscanCount,
    style: style,
    useIsScrolling: useIsScrolling,
    width: width
  }, children);
};

VirtualizedList.displayName = 'VirtualizedList';
export { VirtualizedList };